import { cx } from '@linaria/core';
import { useRef } from 'react';
import { useNotifier } from '@provider/notifier';
import { resets } from '@ui/css';
import { wrapperCls, copyInputWrapperCls, copyButtonCls, copyButtonTextCls, copyInputCls, focusSelector } from './copy-link-button.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function CopyLinkButton(props) {
  const notifier = useNotifier();
  const inputRef = useRef(null);
  const handleButtonClick = async () => {
    const inputElement = inputRef.current;
    if (!inputElement) {
      return;
    }
    await navigator.clipboard.writeText(inputElement.value).then(() => {
      notifier.notify({
        id: `copy-link-${props.href}`,
        type: "success",
        body: "Linket er blevet kopieret"
      });
    }).catch(() => {
      notifier.notify({
        id: `copy-link-${props.href}`,
        type: "error",
        body: "Linket kunne ikke kopieres"
      });
    });
  };
  const handleInputFocus = () => {
    const inputElement = inputRef.current;
    if (!inputElement) {
      return;
    }
    inputElement.select();
  };
  return /*#__PURE__*/jsx("div", {
    className: cx(resets.rootCls, wrapperCls, props.isLoading && "isLoading"),
    children: /*#__PURE__*/jsxs("div", {
      className: copyInputWrapperCls,
      children: [/*#__PURE__*/jsxs("button", {
        className: copyButtonCls,
        onClick: handleButtonClick,
        "aria-label": "Kopi\xE9r link til indholdselementet",
        disabled: props.isLoading,
        children: [props.buttonIcon, /*#__PURE__*/jsx("span", {
          className: copyButtonTextCls,
          children: props.buttonLabel ?? "Kopiér"
        })]
      }), /*#__PURE__*/jsx("input", {
        "aria-hidden": true,
        ref: inputRef,
        className: copyInputCls,
        type: "text",
        readOnly: true,
        value: props.href,
        onFocus: handleInputFocus
      }), /*#__PURE__*/jsx("span", {
        className: focusSelector
      })]
    })
  });
}

export { CopyLinkButton };
//# sourceMappingURL=copy-link-button.js.map
